import { render, staticRenderFns } from "./subAccountDetail.vue?vue&type=template&id=e5f8ff8a&scoped=true&"
import script from "./subAccountDetail.vue?vue&type=script&lang=js&"
export * from "./subAccountDetail.vue?vue&type=script&lang=js&"
import style0 from "./subAccountDetail.vue?vue&type=style&index=0&id=e5f8ff8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f8ff8a",
  null
  
)

export default component.exports